function SponsorCard(sponsor) {
    return (
        <div className="relative flex justify-center items-center mt-10 border-2 border-none rounded-lg hover:shadow-lg">
            <a 
                href={sponsor.link} 
                target="_blank" 
                rel="noreferrer" 
                className="group relative flex justify-center items-center w-[350px] h-[250px] overflow-hidden"
            >
                <img 
                    src={sponsor.logo} 
                    className="w-full h-full object-contain transition-all duration-300 transform group-hover:opacity-70 filter group-hover:blur-sm"  
                    alt={sponsor.name} 
                />

                <div className="absolute inset-0 bg-transparent bg-opacity-50 flex justify-center items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 m-3">
                    <h1 className="text-mainBlue font-bold text-md">{sponsor.description}</h1>
                </div>
            </a>       
        </div>
    );
}

export default SponsorCard;
